import { useToast, UseToastOptions } from '@chakra-ui/react';
import { TOAST_DURATIONS } from '@common/toasts';
import { AlertCircle, CheckCircle, InfoCircle } from './icons';

// TODO: Keep this implementation in sync with mobile/components/Toast.tsx

type ToastInput = string | UseToastOptions | undefined;

export const DEFAULT_TOAST: UseToastOptions = {
    position: 'top',
    duration: TOAST_DURATIONS.long,
    isClosable: true,
    variant: 'solid',
};

export const useSuccessToast = () => {
    const toast = useToast();
    return (input: ToastInput) =>
        toast({
            ...DEFAULT_TOAST,
            status: 'success',
            icon: <CheckCircle />,
            ...toastOptsFromInput(input),
        });
};

export const useInfoToast = () => {
    const toast = useToast();
    return (input: ToastInput) =>
        toast({
            ...DEFAULT_TOAST,
            status: 'info',
            icon: <InfoCircle />,
            ...toastOptsFromInput(input),
        });
};

export const useWarningToast = () => {
    const toast = useToast();
    return (input: ToastInput) =>
        toast({
            ...DEFAULT_TOAST,
            status: 'warning',
            icon: <AlertCircle />,
            ...toastOptsFromInput(input),
        });
};

export const useErrorToast = () => {
    const toast = useToast();
    return (input: ToastInput) =>
        toast({
            ...DEFAULT_TOAST,
            status: 'error',
            icon: <AlertCircle />,
            ...toastOptsFromInput(input),
        });
};

export const useToasts = () => {
    const showSuccessToast = useSuccessToast();
    const showInfoToast = useInfoToast();
    const showWarningToast = useWarningToast();
    const showErrorToast = useErrorToast();

    return {
        showSuccessToast,
        showInfoToast,
        showWarningToast,
        showErrorToast,
    };
};

const toastOptsFromInput = (input: ToastInput): UseToastOptions => {
    const opts: UseToastOptions = !input
        ? {}
        : typeof input === 'string'
          ? { description: input }
          : input;
    return opts;
};
